import { render, staticRenderFns } from "./cModalConsultorios.vue?vue&type=template&id=41b77cda"
import script from "./cModalConsultorios.vue?vue&type=script&lang=js"
export * from "./cModalConsultorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports